import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ZIP_PATH, CITY_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const STATE_SPELL_NAME = "state";

const FillOrigamiStepProps = {
  previous: CITY_PATH,
  next: ZIP_PATH,
  question: "How about the <%= target %>",
  target: "state",
  spellName: STATE_SPELL_NAME,
  placeholder: "TX",
  required: false
};

export const StateStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(StateStep);
